/**
 * Getting a list of ids of all matches used in matchDays.
 */
export const mapMatchIds = (matchDays = []) => {
    const matchIdList = matchDays?.reduce((acc, cur) => {
        // Check if the current object has a "gameDayMatches" property and is an array
        if(cur?.gameDayMatches && Array.isArray(cur?.gameDayMatches)) {
            return [...acc, ...cur?.gameDayMatches]
        } else {
            return acc;
        }
    }, []);
    // Set to get unique ids
    return [...new Set(matchIdList)];
}